// extracted by mini-css-extract-plugin
export default {"file-info-panel":"file-info-panel--HaFiK","group":"group--Buzs9","divider":"divider--TpF7S"};